module.exports = __webpack_public_path__ + "static/section-2-bg-min-ad1f16b31492c8524ba9ec48a6682b27.jpg";